<template>
  <div class="w100 pt20 pb20">
    <div class="w100 pb20">
      <!-- 流程信息 -->
      <div class="title">
        <span>流程信息</span>
        <!-- <el-button type="primary" @click="submitForm('flowForm')">保存</el-button> -->
      </div>
      <el-form :inline="true" label-width="100px" :model="flowForm" :rules="flowRules" ref="flowForm" class="demo-form-inline">
        <el-form-item label="负责单位" prop="unit" style="width: 40%;">
          <el-input style="width: 250px;" v-model="flowForm.unit" placeholder="请输入负责单位"></el-input>
        </el-form-item>
        <el-form-item label="办理时间" prop="time" style="width: 40%;">
          <el-input style="width: 250px;" v-model="flowForm.time" placeholder="请输入办理时间"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone" style="width: 40%;">
          <el-input style="width: 250px;" v-model="flowForm.phone" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="name" style="width: 40%;">
          <el-input style="width: 250px;" v-model="flowForm.name" placeholder="请输入联系人"></el-input>
        </el-form-item>
        <el-form-item label="办理地点" prop="site" style="width: 40%;">
          <el-input style="width: 250px;" v-model="flowForm.site" placeholder="请输入办理地点"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <!-- 使用说明 -->
    <div class="w100 pb20">
      <div class="title mb20">
        <span>使用说明</span>
      </div>
      <el-form label-width="100px" :model="useForm" ref="useForm">
        <el-form-item label="服务说明">
          <el-input v-model="useForm.description" type="textarea" :rows="4" placeholder="请输入服务说明" style="width: 50%; min-width: 500px;"></el-input>
        </el-form-item>
        <el-form-item label="服务文件" style="width: 380px;">
          <el-upload
            class="upload-demo"
            ref="fileUpload"
            :action="uploadUrl"
            :data="fileUploadData"
            :headers="uploadHeader"
            accept=".txt, .docx, .xls"
            :on-change="fileChange"
            :on-remove="fileRemove"
            :file-list="useForm.fileList"
            :before-remove="fileBeforeRemove"
            :on-success="fileSuccess"
            :auto-upload="true"
            :limit="3"
            :on-exceed="handleExceed">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <div slot="tip" class="el-upload__tip">只能上传.txt, .docx, .xls文件，且不超过1M。</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="流程图标">
          <div style="display: flex; flex-direction: row; align-items: center;">
            <el-upload
              ref="imgUpload"
              class="avatar-uploader"
              :action="uploadUrl"
              :data="imgUploadData"
              :headers="uploadHeader"
              accept=".jpg, .png"
              :on-change="onChange"
              :on-success="onSuccess"
              :on-error="onError"
              :auto-upload="false"
              :show-file-list="false">
              <img v-if="useForm.imgUrl" :src="useForm.imgUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <span style="font-size: 12px; color: #e6a23c; padding-left: 8px;">只支持上传.JPG, .PNG文件！</span>
          </div>
        </el-form-item>
        <el-form-item label="服务问题" class="question">
          <div class="flow cl-f">
            <div class="content">
              <el-button type="primary" icon="el-icon-plus" @click="addQuestion" style="margin-bottom: 20px;"></el-button>
              <div class="item cl-f" v-for="(item, index) in useForm.question" :key="item.id">
                <span>{{ index + 1 }}、</span>
                <el-input v-model="item.question" placeholder="请输入问题"></el-input>
                <el-input v-model="item.answer" placeholder="请输入答案"></el-input>
                <el-button type="primary" icon="el-icon-minus" @click="delQuestion(index)"></el-button>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "App",
  components: {},
  props: ["prorData"],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      uploadUrl: this.$http.defaults.baseURL + "/serveFile/upload",
      uploadHeader: {},
      fileUploadData: {}, // 文件上传额外参数
      imgUploadData: {},  // 流程图上传额外参数
      useId: "",  // 使用说明id
      fileListObj: [], // 存储所有上传文件 id、name、url
      flowForm: {
        name: "",
        unit: "",
        phone: "",
        time: "",
        site: ""
      },
      useForm: {
        description: "",
        fileList: [],
        fileIds: [],
        imgUrl: "",
        imgId: "",
        question: []
      },
      shortData: null,  // 保存 获取详情之后的数据，用于判断是新增还是更像
      flowRules: {
        unit: [
          { required: false, message: "请输入负责单位", trigger: "blur" }
        ],
        phone: [
          { required: false, message: "请输入联系电话", trigger: "blur" },
        ],
        name: [
          { required: false, message: "请输入联系人", trigger: "blur" }
        ],
        time: [
          { required: false, message: "请选择办理时间", trigger: "blur" }
        ],
        site: [
          { required: false, message: "请输入办理地点", trigger: "blur" }
        ],
      }
    };
  },
  computed: {
    ...mapGetters(["userToken"])
  },
  created() {},
  mounted() {
    this.uploadHeader = { token: this.userToken, Authorization: "bearer " + this.$keycloak.token }
  },
  destroyed() {},
  methods: {
    // 刷新表单
    refreshForm () {
      this.$nextTick(() => {
        this.$refs["flowForm"].resetFields();
        this.$refs["useForm"].resetFields();
      })
    },

    // 点击 提交
    submitForm (formName) {
      if (!this.prorData.serveId) {
        this.$message.warning("请先新增服务基本信息！");
        return
      }

      this.$refs[formName].validate((valid) => {
        if (valid) {
          if ( this.useForm.imgId === "" && this.useForm.imgUrl ) {
            this.$refs.imgUpload.submit() // 上传图标
          } else {
            this.serveFn();
          }
        } else {
          return false;
        }
      });
    },

    // 提交方法
    serveFn () {
      // 传入参数
      let data = {
        serveInstructions: {
          id: this.useId,
          contactName: this.flowForm.name,
          contactPhone: this.flowForm.phone,
          handleTime: this.flowForm.time,
          handleAddr: this.flowForm.site,
          chargeDept: this.flowForm.unit,
          serveId: this.prorData.serveId,
          serveInstruction: this.useForm.description
        },
        fileIds: [],
        processPhotoId: this.useForm.imgId,
        serveQAList: []
      };

      this.useForm.question.forEach( e => {
        data.serveQAList.push({ id: e.id, question: e.question, answer: e.answer, serveId: this.prorData.serveId })
      })

      this.fileListObj.forEach( e => {
        data.fileIds.push(e.id)
      })

      // 判断 更新 新增
      if ( this.shortData ) {
        this.updateFn(data)
        return
      }

      this.$http.post( "/instruction/add", data )
      .then( ({ data }) => {
        if ( data.resCode === 0 ) {
          this.$message.success("使用说明保存成功！");
        }
        this.$emit("closeFn");
      })
      .catch( () => {});
    },

    // 修改 更新
    updateFn (data) {
      this.$http.post( "/instruction/update", data )
      .then( ({ data }) => {
        if ( data.resCode === 0 ) {
          this.$message.success("使用说明更新成功！");
        }
        this.$emit("closeFn");
      })
      .catch( () => {});
    },

    // 查询 使用详情
    getInfoFn () {
      this.$http.get( "/instruction/detail?serveId=" + this.prorData.serveId )
      .then( ({ data }) => {
        
        this.shortData = data.resData;
        if ( data.resCode === 0 ) {
          let newData = data.resData;
          let qaData = newData.qa;
          let serveData = newData.serveFile;
          let flowData = data.resData.serveInstructions;
          
          this.useId = flowData.id;
          this.flowForm.name = flowData.contactName;
          this.flowForm.unit = flowData.chargeDept;
          this.flowForm.phone = flowData.contactPhone;
          this.flowForm.time = flowData.handleTime;
          this.flowForm.site = flowData.handleAddr;
          this.useForm.description = flowData.serveInstruction;
          
          serveData.forEach( e => {
            this.useForm.fileList.push({ name: e.relatedFileName, url: e.fileUrl })
            this.useForm.fileIds.push(e.id)
            this.fileListObj.push({ id: e.id, name: e.relatedFileName, url: e.fileUrl })
          })
          
          this.useForm.imgUrl = newData.processPhoto ? newData.processPhoto.fileUrl : "";
          this.useForm.imgId = newData.processPhoto ? newData.processPhoto.id : "";
          
          qaData.forEach( e => {
            this.useForm.question.push({ id: e.id, question: e.question, answer: e.answer, serveId: e.serveId })
          })
        } else if ( data.resCode === -1003 ) {
          this.$message.warning("该服务暂无使用说明！");
        }
      })
      .catch( () => {});
    },

    // 新增问题
    addQuestion () {
      let n = this.useForm.question.length + 1;
      this.useForm.question.push({ id: n, title: "", content: "", answer: "", serveId: this.prorData });
    },

    // 删除问题
    delQuestion (index) {
      this.useForm.question.splice(index, 1);
    },

    // 上传文件
    fileChange (file, fileList) {
      const isJPG = file.raw.type === "text/plain" || file.raw.type === "application/vnd.ms-excel" || file.raw.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      const isLt2M = file.size / 1024  < 1024;

      if (!isJPG) {
        this.$message.error('上传文件只能是 .txt, .docx, .xls 格式文件!');
        return;
      }
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 1MB!,请重新上传。');
        return;
      }

      this.useForm.fileList = fileList;
      // 最大上传三个
      // this.fileList = fileList.slice(-3);
    },

    // 流程图 上传成功
    fileSuccess (response, file) {
      this.$nextTick(() => {
        this.useForm.fileIds.push(response.resData[0]);
        this.fileListObj.push({ id: response.resData[0], name: file.name, url: "" })
      })
    },

    // 流程图  选中流程图(用于选中未提交时，显示图片)
    onChange (file) {
      let arr = []
      const isPNG = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
      const isLt2M = file.size / 1024  < 1024;

      if (!isPNG) {
        this.useForm.imgUrl = '';
        this.$message.error('只支持上传.JPG、.PNG文件！');
        return;
      }
      if (!isLt2M) {
        this.useForm.imgUrl = '';
        this.$message.error('上传流程图大小不能超过 1MB!,请重新上传。');
        return;
      }
      
      // 变更图标之后重新赋值，保持只有有个图标
      arr.push(file)
      this.$refs.imgUpload.uploadFiles = arr

      this.useForm.imgId = "";                           // 选择新图片，id要为空
      this.useForm.imgUrl = URL.createObjectURL(file.raw);
    },

    // 流程图 上传成功
    onSuccess (response) {
      this.$nextTick(() => {
        this.useForm.imgId = response.resData[0];
        this.serveFn();
      })
    },

    // 流程图  上传错误
    onError () {
      this.$nextTick(() => {
        this.form.imgUrl = "";
        this.$message.error('网络错误！');
      })
    },

    // 服务文件上传
    // 移除文件
    fileRemove(file) {
      this.fileListObj.splice(this.fileListObj.findIndex( item => item.name === file.name ), 1)
      this.$message.success("文件 " + file.name + " 移除成功！");
    },
    // 文件移除提示
    fileBeforeRemove(file) {
      return this.$confirm(`确定移除 ${ file.name }？`);
    },
    handleExceed() {
      this.$message.warning("只支持上传 3 个文件");
    }
  },
  watch: {
    prorData: {
      handler () {
        this.$nextTick( () => {
          if ( this.prorData.type === "1" ) {
            this.getInfoFn()
          }
        })
      },
      immediate: true
    }
  },
  filters: {}
};
</script>

<style scoped>
  .title {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    border-bottom: 1px solid #f1f2f3;
    padding-bottom: 12px;
  }

  .title span {
    color: #409EFF;
    font-size: 16px;
  }
  .el-form {
    padding-top: 20px;
  }

  .flow {
    margin-bottom: 18px;
  }

  .flow .label,
  .content .item .number {
    width: 100px;
    padding-right: 12px;
    line-height: 32px;
    text-align: right;
    vertical-align: middle;
    font-size: 14px;
    color: #606266;
    float: left;
  }

  .flow .content {
    width: 100%;
    min-height: 32px;
  }

  .content .item {
    margin-bottom: 18px;
  }

  .content .item .el-input {
    width: 400px;
    margin-right: 10px;
  }

  .avatar-uploader {
    width: 32px;
    height: 32px;
    display: block;
    border: 1px solid #cdcdcd;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .avatar-uploader .avatar {
    width: 32px;
    height: 32px;
    display: block;
  }
</style>
